import styled, { css } from "styled-components";

import Props from "./props";

const ModalWrapper = styled.div<Props>`
    background-color: ${props => props.theme.colors.white(1)};
    padding: 2rem;
    position: relative;
    box-shadow: 0px 11px 15px -7px ${props => props.theme.colors.black(0.2)}, 0px 24px 38px 3px ${props => props.theme.colors.black(0.14)},
        0px 9px 46px 8px ${props => props.theme.colors.black(0.12)};
    border-radius: 4px;
    width: 100%;
    max-width: 20rem;
    min-height: 12rem;
    transition: opacity 0.3s ease, transform 0.3s ease;
    margin: 0 auto;
    top: 7rem;
    ${({ open }) => css`
        opacity: ${open ? 1 : 0};
        transform: translateY(${open ? 0 : 2}rem);
    `}
`;

export default ModalWrapper;
